export const proxyPolyfillCompat = {
  trace: null,
  instrumentationEnabled: null,
  dataCollectionEnabled: null,
};
